import { useEffect } from 'react';

export default function useAutoFocus(inputRef, enabled) {
  return useEffect(() => {
    if (enabled && inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef]);
}
